import React, { useRef, useState }  from 'react';
import emailjs from '@emailjs/browser';
import { Footer } from '../../../../containers';
import { Navbar } from '../../../../components';
import './Oi-Xwroi-Mas.css';
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from 'react-accessible-accordion';
import 'react-accessible-accordion/dist/fancy-example.css';
import OEFE from '../../../../assets/OEFE.jpg';
import labora from '../../../../assets/labora.jpg';
import edu4schools from '../../../../assets/edu4schools.png';
import ypourgeio from '../../../../assets/ypourgeio.jpg';
import Video1 from './Photo/Xwroi-video.mp4';

const categories = [
  { title: "1", image: require("./Photo/1.JPEG") },
  { title: "2", image: require("./Photo/2.JPEG") },
  { title: "3", image: require("./Photo/3.JPEG") },
  { title: "4", image: require("./Photo/4.JPEG") },
  { title: "5", image: require("./Photo/5.JPEG") },
  { title: "6", image: require("./Photo/6.JPEG") },
  { title: "7", image: require("./Photo/7.JPEG") },
  { title: "8", image: require("./Photo/8.JPEG") },
  { title: "9", image: require("./Photo/9.JPEG") },
  { title: "10", image: require("./Photo/10.JPEG") },
  { title: "11", image: require("./Photo/11.JPEG") },
  { title: "12", image: require("./Photo/12.JPEG") },
  { title: "13", image: require("./Photo/13.JPEG") },
  { title: "14", image: require("./Photo/14.JPEG") },
  { title: "15", image: require("./Photo/15.JPEG") },
  { title: "16", image: require("./Photo/16.jpeg") }
];

const styles = {
  gridContainer: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
    gap: "16px",
    padding: "20px",
    maxWidth: "1000px",
    margin: "auto",
  },
  gridItem: {
    background: "white",
    border: "1px solid #ddd",
    borderRadius: "8px",
    overflow: "hidden",
    textAlign: "center",
    boxShadow: "2px 2px 10px rgba(0, 0, 0, 0.1)",
    transition: "transform 0.2s ease-in-out",
    cursor: "pointer",
  },
  gridItemHover: {
    transform: "scale(1.05)",
  },
  gridImage: {
    width: "100%",
    height: "150px",
    objectFit: "cover",
  },
  title: {
    padding: "10px",
    fontSize: "16px",
    fontWeight: "bold",
    background: "#f8f8f8",
  },
  fullscreenOverlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    background: "rgba(0, 0, 0, 0.8)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: "1000",
  },
  fullscreenImage: {
    maxWidth: "90%",
    maxHeight: "90%",
    
  },
};

const Xwroi = () => {
  
  const [fullscreenImage, setFullscreenImage] = useState(null);
  const [hoverIndex, setHoverIndex] = useState(null);



  const form = useRef();
  const [showSuccess, setShowSuccess] = useState(false);
  const [showError, setShowError] = useState(false);

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm('service_ald9cce', 'template_optgjil', form.current, 'EVgIFCLIjxstCs_IK')
      .then((result) => {
          console.log(result.text);
          console.log("message sent");
          e.target.reset();
          setShowSuccess(true);
          setShowError(false);
      }, (error) => {
          console.log(error.text);
          setShowSuccess(false);
          setShowError(true);
      });
  };

  const closePopup = () => {
    setShowSuccess(false);
    setShowError(false);
  };



  return (
    <div className="Xwroi">
        <div className="gradient__bg">
          <Navbar className="navbar" />
        </div>
        <div className="Xwroi__main-container">
          <div className="Xwroi__container">
            <div className="Xwroi__container-h">
              <h1>Οι Χώροι μας</h1>
            </div>
            <div style={styles.gridContainer}>
              {categories.map((category, index) => (
                <div
                  key={index}
                  style={{
                    ...styles.gridItem,
                    ...(hoverIndex === index ? styles.gridItemHover : {}),
                  }}
                  onClick={() => setFullscreenImage(category.image)}
                  onMouseEnter={() => setHoverIndex(index)}
                  onMouseLeave={() => setHoverIndex(null)}
                >
                  <img src={category.image} alt={category.title} style={styles.gridImage} />
                </div>
              ))}
            </div>
            {fullscreenImage && (
              <div
                style={styles.fullscreenOverlay}
                onClick={() => setFullscreenImage(null)}
              >
                <img src={fullscreenImage} alt="Fullscreen" style={styles.fullscreenImage} />
              </div>
            )}
            <div className="Xwroi__container-p">
            <p>&nbsp;&nbsp;&nbsp;Χώροι, εγκαταστάσεις και ιδιοκτησιακό καθεστώς. </p>
              <p>&nbsp;&nbsp;&nbsp;Η εταιρεία μετέφερε την έδρα και τις εγκαταστάσεις της, αρχές του 2008, στη νέα διεύθυνση Ρούπελ 6, στον πεζόδρομο του Σιδηροκάστρου (πίσω από τα ΚΤΕΛ). Στεγάζεται στον δεύτερο όροφο νεοδόμητης πολυκατοικίας. Καταλαμβάνει ολόκληρο τον όροφο και χωρίζεται σε δύο κτίρια  που ενώνονται με κοινό διάδρομο. </p>
              <p>&nbsp;&nbsp;&nbsp;Το πρώτο τμήμα περιλαμβάνει:
                  <p>&nbsp;&nbsp;&nbsp;&bull; τον χώρο υποδοχής και την γραμματεία της εταιρείας,</p> 
                  <p>&nbsp;&nbsp;&nbsp;&bull; χώρο παραμονής των σπουδαστών, κατά την διάρκεια των διαλλειμάτων,</p> 
                  <p>&nbsp;&nbsp;&nbsp;&bull; το γραφείο των καθηγητών που εργάζονται στην επιχείρηση,</p>
                  <p>&nbsp;&nbsp;&nbsp;&bull; χώρο υγιεινής,</p>
                  <p>&nbsp;&nbsp;&nbsp;&bull; χώρο με εγκαταστάσεις κουζίνας,</p>
                  <p>&nbsp;&nbsp;&nbsp;&bull; 3 αίθουσες διδασκαλίας με οκτώ θέσεις σπουδαστών</p>
              </p>
              <p>&nbsp;&nbsp;&nbsp;Το δεύτερο τμήμα περιλαμβάνει:
                  <p>&nbsp;&nbsp;&nbsp;&bull; αίθουσα πολλαπλών χρήσεων με 15 θέσεις σπουδαστών,</p> 
                  <p>&nbsp;&nbsp;&nbsp;&bull; χώρο παραμονής των σπουδαστών, κατά την διάρκεια των διαλλειμάτων,</p> 
                  <p>&nbsp;&nbsp;&nbsp;&bull; αίθουσα διδασκαλίας με 8 θέσεις σπουδαστών,</p>
                  <p>&nbsp;&nbsp;&nbsp;&bull; αίθουσα διδασκαλίας με 6 θέσεις σπουδαστών,</p>
                  <p>&nbsp;&nbsp;&nbsp;&bull; χώρο υγιεινής,</p>
                  <p>&nbsp;&nbsp;&nbsp;&bull; βιβλιοθήκη</p>
              </p>
            </div>
          </div>
          <div className="Xwroi__side-Containers">
            <div className="Xwroi__side-Container1">
              <h1>Χρήσιμες Σελίδες</h1>
              <Accordion allowZeroExpanded allowMultipleExpanded preExpanded={['a']}>
                  <AccordionItem uuid="a">
                    <AccordionItemHeading>
                      <AccordionItemButton>
                        Σημεία Υπεροχής
                      </AccordionItemButton>
                    </AccordionItemHeading>
                      <AccordionItemPanel>
                        <p>
                        Το φροντιστήριο φημίζεται ως  το πιο οργανωμένο και φιλικό προς τους μαθητές του εκπαιδευτήριο. Σε συνδυασμό με την άψογη συνεργασία των καθηγητών του το καθιστά ένα από τα καλύτερα της περιοχής μας.
                        </p>
                        <a href="/Frontistirio/Paroxes-Ypiresiwn/" target="_blank" rel="noopener noreferrer">
                          <button class="custom-btn btn-5">Λεπτομέρειες</button>
                        </a>
                        </AccordionItemPanel>
                  </AccordionItem>
                    <AccordionItem>
                      <AccordionItemHeading>
                        <AccordionItemButton>
                        "Ομάδα ή Μονάδα" ;
                        </AccordionItemButton>
                      </AccordionItemHeading>
                        <AccordionItemPanel>
                          <p>
                          Το παιδί και ο έφηβος μαθαίνουν καλύτερα το «τι» και το «πως» μαζί με τους άλλους. “Learning together, learning to live together”  -UNESCO- 
                          </p>
                          <a href="/OmadaMonada" target="_blank" rel="noopener noreferrer">
                            <button class="custom-btn btn-5">Λεπτομέρειες</button>
                          </a>
                        </AccordionItemPanel>
                    </AccordionItem>
                    <AccordionItem>
                      <AccordionItemHeading>
                        <AccordionItemButton>
                        Πρόταση "ΑΝΟΔΟΥ" για Πανελλήνιες
                        </AccordionItemButton>
                      </AccordionItemHeading>
                        <AccordionItemPanel>
                          <p>
                          Οι υπεύθυνοι σπουδών του  φροντιστηρίου μας, μετά από τόσα χρόνια εμπειρίας είναι ικανοί  να προτείνουν την καλύτερη πρόταση ώστε να επιτύχει ο μαθητής  τον στόχο του.
                          </p>
                          <a href="/Mathimata/B-Lykeiou" target="_blank" rel="noopener noreferrer">
                            <button class="custom-btn btn-5">Λεπτομέρειες</button>
                          </a>
                        </AccordionItemPanel>
                    </AccordionItem>
                    <AccordionItem>
                      <AccordionItemHeading>
                        <AccordionItemButton>
                          Σχόλια Μαθητών
                        </AccordionItemButton>
                      </AccordionItemHeading>
                        <AccordionItemPanel>
                          <p>
                          Οι απόψεις των μαθητών μας για την λειτουργία του φροντιστηρίου αποτελούν κίνητρο για σκληρή και απαιτητική δουλειά, ωστόσο τα θετικά σχόλια είναι η ανταπόδοση όλων των προσπαθειών των καθηγητών μας . 
                          </p>
                          <a href="/PoioiEimaste/Oi-Mathites-Mas/" target="_blank" rel="noopener noreferrer">
                            <button class="custom-btn btn-5">Λεπτομέρειες</button>
                          </a>
                        </AccordionItemPanel>
                    </AccordionItem>
                </Accordion>
            </div>
            <div className='xwroi-video'>
              <video width="70%" controls autoPlay muted loop>
                <source src={Video1} type="video/mp4"/>
                error
              </video>
            </div>
            <div className="xwroi-email-container">
              <form className="xwroi-email-container_form" ref={form} onSubmit={sendEmail}>
                <h1 className="xwroi-email-container_h1">Φόρμα Επικοινωνίας</h1>
                <label className="xwroi-email-container_label">Όνομα</label>
                <input className="xwroi-email-container_input" type="text" name="user_name" required/>
                <label className="xwroi-email-container_label">Email</label>
                <input className="xwroi-email-container_input" type="email" name="user_email" required/>
                <label className="xwroi-email-container_label">Μήνυμα</label>
                <textarea className="xwroi-email-container_input-message" name="message" required/>
                <input className="xwroi-email-container_btn" type="submit" value="Αποστολή" />
              </form>

              {showSuccess && (
                <div className="xwroi-email-container_popup xwroi-email-container_popup--success">
                  <span>Your message was sent successfully!</span>
                  <button className="xwroi-email-container_close" onClick={closePopup}>X</button>
                </div>
              )}

              {showError && (
                <div className="xwroi-email-container_popup xwroi-email-container_popup--error">
                  <span>There was an error sending your message. Please try again later.</span>
                  <button className="xwroi-email-container_close" onClick={closePopup}>X</button>
                </div>
              )}
              </div>
            <div className="xwroi-links-container">
                <a href="https://www.oefe.gr/" target="_blank" rel="noopener noreferrer">
                    <div className="xwroi-links-container_box" style={{ backgroundImage: `url(${OEFE})` }}></div>
                </a>
                <a href="https://labora.gr/" target="_blank" rel="noopener noreferrer">
                    <div className="xwroi-links-container_box" style={{ backgroundImage: `url(${labora})` }}></div>
                </a>
                <a href="https://www.edu4schools.gr/" target="_blank" rel="noopener noreferrer">
                    <div className="xwroi-links-container_box" style={{ backgroundImage: `url(${edu4schools})` }}></div>
                </a>
                <a href="https://www.minedu.gov.gr/" target="_blank" rel="noopener noreferrer">
                    <div className="xwroi-links-container_box" style={{ backgroundImage: `url(${ypourgeio})` }}></div>
                </a>
            </div>
          </div>
        </div>
        <Footer />
    </div>
  )
}

export default Xwroi